import React, { useState, useEffect} from 'react';
import axios from "axios";
import { API_URL, BASE_URL } from './Config';
import config from "./common/Config";
import { toast } from 'sonner';
import CommonDatePicker from './datepicker/CommonDatePicker';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  TableContainer,
  TextField,
  InputAdornment,
  TablePagination,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Skeleton,
  Link as MuiLink,
  Chip,
  Grid2,
} from '@mui/material';
import { Iconify } from './Minimal/src/components/iconify/iconify';
import "./common/commonStyles.css";
import { getCompanySettings, resolveCustomerApiEncrypt } from "../utils/companySettingsCache";
import { encryptPayload, normalizeEncryptedApiResponse } from "../utils/customerCrypto";
const columns = [
  { id: "sr_no", label: "Sr.No.", width: 60 },
  { id: "date", label: "Date", width: 120 },
  { id: "trip_number", label: "Trip ID", width: 120 },
  { id: "driver", label: "Driver", width: 150 },
  { id: "vehicle", label: "Vehicle", width: 150 },
  { id: "route_number", label: "Route", width: 150 },
  { id: "status", label: "Status", width: 120 },
  { id: "action", label: "Action", width: 120 },
];

const OpenTrips = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [options, setOptions] = useState([]);
  const [vehicles, setSelectedVehicles] = useState('');
  const [tripid, setTripid] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem("token");

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    async function fetchVehicleOptions() {
      try {
        const settings = await getCompanySettings();
        const useEncrypt = resolveCustomerApiEncrypt(settings);
        let postBody;
        if (useEncrypt) {
          const ep = encryptPayload({});
          if (!ep) {
            return;
          }
          const fd = new FormData();
          fd.append("encrypted_payload", ep);
          postBody = fd;
        } else {
          postBody = {};
        }

        const response = await axios.post(
          `${config.API_URL}/get-vehicles_web`,
          postBody,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          }
        );

        const payload = normalizeEncryptedApiResponse(response.data, useEncrypt) ?? response.data;

        if (!payload || !payload.data || !Array.isArray(payload.data)) {
          throw new Error('Invalid response format or empty vehicle array');
        }

        const formattedOptions = payload.data.map(item => ({
          key: `${item.modelName}`,
          value: item.vehicleId,
        }));

        setOptions(formattedOptions);
      } catch {
      }
    }

    fetchVehicleOptions();
  }, [accessToken]);

  const [showVehicleModal, setShowVehicleModal] = useState(false);

  const fetchData = async () => {
    if (!accessToken || !token) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    setLoading(true);
    try {
      const settings = await getCompanySettings();
      const useEncrypt = resolveCustomerApiEncrypt(settings);
      const headers = { authorization: `Bearer ${token}` };
      let body;
      if (useEncrypt) {
        const plain = {
          searchByFromdate: fromDate,
          searchByTodate: toDate,
          draw: String(page + 1),
          start: String(page * rowsPerPage),
          length: String(rowsPerPage),
          role: selectedRole,
          search: { value: searchTerm },
        };
        const ep = encryptPayload(plain);
        if (!ep) {
          setData([]);
          setTotalRecords(0);
          return;
        }
        const fd = new FormData();
        fd.append("encrypted_payload", ep);
        body = fd;
      } else {
        const formData = new FormData();
        formData.append('searchByFromdate', fromDate);
        formData.append('searchByTodate', toDate);
        formData.append('draw', page + 1);
        formData.append('start', page * rowsPerPage);
        formData.append('length', rowsPerPage);
        formData.append('role', selectedRole);
        formData.append('search[value]', searchTerm);
        body = formData;
      }

      const response = await fetch(`${config.API_URL}/get_trip_list`, {
        method: 'POST',
        headers,
        body,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const rawJson = await response.json();
      const json = normalizeEncryptedApiResponse(rawJson, useEncrypt) ?? rawJson;
      const trips = Array.isArray(json.data) ? json.data : [];

      // Add serial numbers
      const tripsWithSrNo = trips.map((trip, index) => ({
        ...trip,
        sr_no: page * rowsPerPage + index + 1
      }));

      setData(tripsWithSrNo);
      setTotalRecords(json.recordsTotal || json.recordsFiltered || trips.length);
    } catch {
      setData([]);
      setTotalRecords(0);
      toast.error('Failed to load trips');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchData();
  }, [fromDate, toDate, selectedRole, page, rowsPerPage, searchTerm, accessToken]);

  const updateVehicleInfo = async () => {
    let vehiclesID = `${vehicles}`;
    if (!vehiclesID) {
      toast.error('Please Select vehicle.');
      return;
    }

    try {
      const settings = await getCompanySettings();
      const useEncrypt = resolveCustomerApiEncrypt(settings);
      const headers = { authorization: `Bearer ${accessToken}` };
      let body;
      if (useEncrypt) {
        const ep = encryptPayload({
          tripId: String(tripid),
          vehicle_id: String(vehiclesID),
        });
        if (!ep) {
          toast.error('Error updating vehicle. Please try again.');
          return;
        }
        const fd = new FormData();
        fd.append("encrypted_payload", ep);
        body = fd;
      } else {
        const formOrder = new FormData();
        formOrder.append('tripId', tripid);
        formOrder.append('vehicle_id', vehiclesID);
        body = formOrder;
      }

      const res = await fetch(`${config.API_URL}/update_trip_vehicle`, {
        method: 'POST',
        headers,
        body,
      });
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const rawJson = await res.json();
      const payload = normalizeEncryptedApiResponse(rawJson, useEncrypt) ?? rawJson;
      if (payload && payload.success === false) {
        toast.error(payload.message || 'Failed to update vehicle.');
        return;
      }
      toast.success('Vehicle updated successfully!');
      setShowVehicleModal(false);
      setSelectedVehicles('');
      fetchData();
    } catch {
      toast.error('Error updating vehicle. Please try again.');
    }
  };

  const viewVechMdl = (tripId) => {
    setTripid(tripId);
    setShowVehicleModal(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
    setSearchTerm(value);
    setPage(0);
  };

  const handleSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setPage(0);
    }
  };

  return (
    <>
        <Box sx={{ px:2,pb:1 }}>
          <Grid2 container spacing={1} display="flex" alignItems="center" justifyContent="space-between">
            <Grid2 size={{ xs: 12, md: 5}}>
              <Typography className="page-title">
                Open Trips
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }} display="flex" justifyContent="flex-end">
              <TextField
                className="input-border"
                size="small"
                fullWidth
                placeholder="Search trips..."
                value={searchInputValue}
                onChange={handleSearchChange}
                onKeyDown={handleSearchKeyDown}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon="eva:search-outline"/>
                      </InputAdornment>
                    )
                  }
                }}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 3 }}>
              <Box>
                <CommonDatePicker
                  className="input-border"
                  value={fromDate && toDate ? [new Date(fromDate), new Date(toDate)] : [null, null]}
                  onChange={val => {
                    if (val && Array.isArray(val) && val[0] && val[1]) {
                      const startDate = val[0];
                      const endDate = val[1];
                      const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                      setFromDate(formatDate(startDate));
                      setToDate(formatDate(endDate));
                    } else {
                      setFromDate('');
                      setToDate('');
                    }
                  }}
                  showOneCalendar
                  format="yyyy-MM-dd"
                  character=" - "
                />
              </Box>
            </Grid2>
          </Grid2>
        </Box>
        <TableContainer sx={{ width: "100%", overflowX: "auto" }}>
          <Table
            size="medium"
            className="table-cell-border"
            sx={{
              tableLayout: "fixed",
            }}
          >
            <TableHead>
              <TableRow className="table-cell-header">
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.id === "sr_no" || column.id === "status" || column.id === "vehicle" ? "center" : "left"}
                    sx={{
                  
                      width: column.width,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody >
              {loading
                ? Array.from({ length: rowsPerPage }).map((_, index) => (
                  <TableRow key={`skeleton-${index}`}>
                    {columns.map((column) => (
                      <TableCell
                        key={`${column.id}-${index}`}
                        align={column.id === "sr_no" || column.id === "status" || column.id === "vehicle" ? "center" : "left"}
                        sx={{
                          py: 1,
                          fontSize: "0.75rem",
                        }}
                      >
                        <Skeleton variant="text" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
                : data.length > 0
                  ? data.map((row) => (
                    <TableRow
                      key={row.id || row.trip_number}
                      hover
                      className="table-cell-style"
                      >
                      <TableCell align="center" >
                        {row.sr_no}
                      </TableCell>
                      <TableCell >
                        {row.date}
                      </TableCell>
                      <TableCell >
                        <MuiLink
                          href={`${BASE_URL}/open_trips/trip_summary/${row.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            color: "inherit",
                            textDecoration: "underline !important",
                            textDecorationColor: "currentColor",
                            textUnderlineOffset: "2px",
                            "&:hover": {
                              textDecoration: "underline !important",
                              textDecorationColor: "currentColor"
                            }
                          }}
                        >
                          {row.trip_number}
                        </MuiLink>
                      </TableCell>
                      <TableCell >
                        {row.driver}
                      </TableCell>
                      <TableCell align="center" >
                        {row.vehicle}
                      </TableCell>
                      <TableCell >
                        {row.route_number}
                      </TableCell>
                      <TableCell align="center" >
                        <Chip
                          label={row.status}
                          size="small"
                        
                          sx={{
                            fontWeight: 500,
                            fontSize: '0.7rem',
                            height: 24,
                            backgroundColor: "#FFD399",
                            color: "#000",
                            "&:hover": {
                              backgroundColor: "#FFD399",
                              color: "#000",
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell >
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => viewVechMdl(row.id)}
                          sx={{
                            textTransform: "none",
                            fontSize: "0.75rem",
                            px: 1.5,
                            py: 0.5,
                            borderColor: "#F8991D",
                          }}
                        >
                          Change Vehicle
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                  : (
                    <TableRow>
                      <TableCell colSpan={columns.length} sx={{ py: 4 }}>
                        <Typography align="center" sx={{ color: "#637381", fontSize: "0.75rem" }}>
                          No records found.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
            </TableBody>
          </Table>
        </TableContainer>
        {data.length > 0 && (
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <TablePagination
              component="div"
              count={totalRecords}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              className="pagination-styles"
            />
          </Box>
        )}
      <Dialog
        open={showVehicleModal}
        onClose={() => setShowVehicleModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography className="page-title">
            Update Vehicle
          </Typography>
          <IconButton
            onClick={() => setShowVehicleModal(false)}
            sx={{ color: '#637381' }}
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <FormControl fullWidth sx={{ mt:2}}>
            <InputLabel id="vehicle-select-label">Select a vehicle</InputLabel>
            <Select
              className="input-border"
              labelId="vehicle-select-label"
              id="vehicle-select"
              value={vehicles}
              label="Select a vehicle"
              onChange={(e) => setSelectedVehicles(e.target.value)}
            >
              <MenuItem value="">
                <em>Select a vehicle</em>
              </MenuItem>
              {options.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => setShowVehicleModal(false)}
            variant="outlined"
            className="button-variant-outlined"

          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              updateVehicleInfo();
              setShowVehicleModal(false);
            }}
       
            className="button-variant-contained"
          >
            Submit changes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OpenTrips;
